/**
 * @abstract
 */
class AbstractLine {
    constructor() {
        /**
         * The branch this line comes from.
         * It might be different from the order branch selected,
         * and a cart/order might contain lines from more than one branch.
         *
         * @type {Branch}
         */
        this.branch = null;

        /**
         * @type {AbstractItem}
         */
        this.item = null;

        /**
         * @type {?Session}
         */
        this.session = null;

        /**
         * The price of a single item on this line.
         *
         * @type {number}
         */
        this.price = 0.00;

        /**
         * The booking fee per item.
         * Normally there are no booking fees on ProPoint, but there may be one when an
         * item from an existing order is being edited.
         *
         * @type {number}
         */
        this.bookingFee = 0.00;

        /**
         * The total of booking fees (bookingFee * qty).
         *
         * @type {number}
         */
        this.bookingFeeSubtotal = 0.00;

        /**
         * Line total (price * qty) before any fees and discounts.
         *
         * @type {number}
         */
        this.baseTotal = 0.00;

        /**
         * The total amount saved on this line by discounts (for the whole line, not per item)
         * (calculated for percentage discounts).
         *
         * @type {number}
         */
        this.discountAmount = 0.00;

        /**
         * The final total price of the line:
         *
         * ((price * qty) - (discountAmount)) + (bookingFee * qty)
         * =
         * (baseTotal - discountAmount) + bookingFeeSubtotal
         * =
         * discountedBaseTotal + bookingFeeSubtotal
         * =
         * lineTotal
         *
         * @type {number}
         */
        this.lineTotal = 0.00;

        /**
         * If this line has been added as a response to an OptionSet, record the set that it refers to.
         * This is necessary so that we can display the question (e.g. "Which sauce?") and not just the
         * answer, which is the ItemOption (e.g. "Truffle Mayo").
         *
         * @type {OptionSet|null}
         */
        this.optionSet = null;
    }

    /**
     * @return {AbstractItem}
     */
    getItem() {
        return this.item;
    }

    /**
     * @abstract
     *
     * @return {string}
     */
    getItemType() {
        // To be implemented by subclasses.
    }

    /**
     * @returns {?Session}
     */
    getSession() {
        return this.session;
    }

    /**
     * @abstract
     */
    getQuantity() {
        // To be implemented by subclasses.
    }
}

module.exports = AbstractLine;
